import { Button } from '../Button';

export const Tabbing = ({
  tabsArray = [],
  tab,
  setTab = () => {},
  width = '130',
}) => {
  if (!tabsArray?.length) return null;
  return (
    <div className="w--full d--flex gap--xs overflow--auto  tabbingAccolcate">
      {tabsArray.map(
        (
          {
            label,
            value,
            count = null,
            activeVariant = 'primary',
            inactiveVariant = 'black-100',
            activeColor = 'white',
            inactiveColor = 'black-800',
            activeBtnClasses = '',
            inactiveBtnClasses = '',
          },
          index,
        ) => {
          const isActive = tab === value;

          return (
            <Button
              key={index}
              variant={isActive ? activeVariant : inactiveVariant}
              color={isActive ? activeColor : inactiveColor}
              btnClasses={`btn w-max--${width} gap--sm white-space--nowrap ${isActive ? activeBtnClasses : inactiveBtnClasses}`}
              onClick={() => {
                setTab(value);
              }}
            >
              {label}
              {typeof count === 'number' && <div className="font--2xs">({count})</div>}
            </Button>
          );
        },
      )}
    </div>
  );
};
